import React from 'react'
import clsx from 'clsx'
import { merge } from 'lodash'

import Modal from '../../Modal'

import { useBreakpoint } from '../../../../providers/BreakpointProvider'
import useStyles from './styles'

const resWidth = 'calc(100% - 4rem)'
const resHeight = 'calc(100% - 3rem)'

const BaseModal = ({
  children,
  method,
  onMethodChange,
  title = 'NEW CUSTOMER CHAT',
  PaperProps,
  className,
  showTitleOnMobile = false,
  variant,
  noOverflow,
  footerActions = undefined,
  childrenClass = undefined,
  ...props
}) => {
  const { isMedium, isNotSmall } = useBreakpoint()
  const showTitle = showTitleOnMobile || isNotSmall

  const extraPaperProps = React.useMemo(
    () => ({
      style: !isMedium
        ? {
            borderRadius: '0.75rem'
          }
        : {
            minWidth: resWidth,
            width: resWidth,
            maxWidth: resWidth,
            minHeight: resHeight,
            height: resHeight,
            maxHeight: resHeight,
            top: '50%',
            left: '50%',
            borderRadius: '0'
          }
    }),
    [isMedium]
  )

  const classes = useStyles({ noOverflow })

  if (!props.open) {
    return null
  }

  return (
    <Modal PaperProps={merge(PaperProps, extraPaperProps)} {...props}>
      <div
        data-testid='modal'
        className={clsx(variant ? classes[variant] : classes.root, className)}
      >
        {showTitle && <div className={classes.title}>{title}</div>}

        <div className={clsx(classes.children, childrenClass)}>{children}</div>
      </div>
      {footerActions && footerActions}
    </Modal>
  )
}

export default BaseModal
